/* NoirClave Urgency — Timer + Viewing + Stock + Toast */
(function(){
  var cfg = window.NC_URGENCY_CFG || {};
  function $(s, r){ return (r||document).querySelectorAll(s); }
  function pad(n){ return n < 10 ? '0'+n : n; }
  function rand(a,b){ return Math.floor(Math.random()*(b-a+1))+a; }
  function get(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } }
  function set(k,v){ try{ localStorage.setItem(k,v); }catch(e){} }

  /* ---------- DEAL TIMER (global per-visitor) ---------- */
  var deadline = 0;
  var durationMs = 0;
  function timerTick(){
    var remain = deadline - Date.now();
    if(remain <= 0){
      /* loop ngay: tạo deadline mới + reset stock cho product hiện tại */
      deadline = Date.now() + durationMs;
      set('nc_deal_expires_at', deadline);
      resetStockForProduct();
      remain = durationMs;
    }
    var h = Math.floor(remain / 3600000);
    var m = Math.floor((remain % 3600000) / 60000);
    var s = Math.floor((remain % 60000) / 1000);
    var txt = h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    $('[data-nc-timer]').forEach(function(el){ el.textContent = txt; });
  }
  function initTimer(){
    if(!cfg.timer_enabled) return;
    durationMs = (cfg.timer_hours || 3) * 3600 * 1000;
    var stored = parseInt(get('nc_deal_expires_at') || '0', 10);
    var storedH = parseInt(get('nc_deal_duration_h') || '0', 10);
    if(!stored || stored < Date.now() || storedH !== cfg.timer_hours){
      deadline = Date.now() + durationMs;
      set('nc_deal_expires_at', deadline);
      set('nc_deal_duration_h', cfg.timer_hours);
    } else {
      deadline = stored;
    }
    timerTick();
    setInterval(timerTick, 1000);
  }

  /* ---------- PEOPLE VIEWING ---------- */
  function initViewing(){
    if(!cfg.viewing_enabled) return;
    var min = cfg.viewing_min, max = cfg.viewing_max;
    var rotateMs = (cfg.viewing_rotate_min || 3) * 60000;
    var stored = parseInt(get('nc_viewing_count') || '0', 10);
    var updatedAt = parseInt(get('nc_viewing_updated_at') || '0', 10);
    if(!stored || Date.now() - updatedAt > rotateMs){
      stored = rand(min, max);
      set('nc_viewing_count', stored);
      set('nc_viewing_updated_at', Date.now());
      updatedAt = Date.now();
    }
    $('[data-nc-viewing]').forEach(function(el){ el.textContent = stored; });
    var remain = Math.max(0, rotateMs - (Date.now() - updatedAt));
    setTimeout(function loop(){
      var n = rand(min, max);
      set('nc_viewing_count', n);
      set('nc_viewing_updated_at', Date.now());
      $('[data-nc-viewing]').forEach(function(el){ el.textContent = n; });
      setTimeout(loop, rotateMs);
    }, remain);
  }

  /* ---------- STOCK (per-product) ---------- */
  function getRange(){
    var t = cfg.product_tier || 'mid';
    if(t === 'low') return [cfg.stock_low_min, cfg.stock_low_max];
    if(t === 'high') return [cfg.stock_high_min, cfg.stock_high_max];
    return [cfg.stock_mid_min, cfg.stock_mid_max];
  }
  function stockKey(){ return 'nc_stock_' + (cfg.product_handle || 'default'); }
  function paintStock(n){
    $('[data-nc-stock]').forEach(function(el){ el.textContent = n; });
  }
  function resetStockForProduct(){
    if(!cfg.stock_enabled || !cfg.product_handle) return;
    var r = getRange();
    var n = rand(r[0], r[1]);
    set(stockKey(), n);
    paintStock(n);
  }
  function initStock(){
    if(!cfg.stock_enabled || !cfg.product_handle) return;
    var floor = cfg.stock_floor || 2;
    var stepMs = (cfg.stock_decrement_sec || 90) * 1000;
    var stored = parseInt(get(stockKey()) || '0', 10);
    if(!stored){
      var r = getRange();
      stored = rand(r[0], r[1]);
      set(stockKey(), stored);
    }
    paintStock(stored);
    setInterval(function(){
      var cur = parseInt(get(stockKey()) || '0', 10);
      if(cur > floor){
        cur -= 1;
        set(stockKey(), cur);
        paintStock(cur);
        if(cfg.toast_enabled) showToast();
      }
    }, stepMs);
  }

  /* ---------- TOAST ---------- */
  var names = ['Emma','Sophia','Olivia','Ava','Isabella','Mia','Charlotte','Amelia','Harper','Evelyn','Chloe','Grace','Zoe','Ella','Lily','Aria','Nora','Hannah','Layla','Scarlett'];
  var cities = ['London','Paris','New York','Sydney','Berlin','Toronto','Milan','Madrid','Amsterdam','Copenhagen','Vienna','Dublin','Zurich','Stockholm','Oslo'];
  function showToast(){
    var el = document.createElement('div');
    el.className = 'nc-toast';
    el.innerHTML = '<div class="nc-toast-icon">✓</div><div class="nc-toast-txt"><strong>'+names[rand(0,names.length-1)]+' from '+cities[rand(0,cities.length-1)]+'</strong><span>just checked out</span></div>';
    document.body.appendChild(el);
    requestAnimationFrame(function(){ el.classList.add('on'); });
    setTimeout(function(){ el.classList.remove('on'); }, 4500);
    setTimeout(function(){ el.remove(); }, 5000);
  }

  function boot(){
    initTimer();
    initViewing();
    initStock();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();